import type {
	SpacingTypes,
	ColorTypes,
	SizeTypes,
	FontTypes,
	TextTypes,
	TypograhyTypes,
} from './styled';
import { DefaultTheme } from 'styled-components';

const theme = (currentTheme: DefaultTheme) => {
	const spacing: SpacingTypes = {
		sm1: '4px',
		sm2: '8px',
		rg1: '12px',
		rg2: '16px',
		lg1: '20px',
		lg2: '24px',
		ma1: '32px',
		ma2: '48px',
		ma3: '64px',
	};

	const color: ColorTypes = {
		//variant description
		primary: '#255AA5', // brand Color
		warning: '#FDB849',
		success: '#1ED760',
		info: '#143E9F',
		danger: '#FF3350',
		white: '#ffffff',
		status: '#AFB4BB',

		//common

		background: '#ffffff',
		text: 'black',
		gray: {
			90: '#1D2530',
			80: '#343C46',
			70: '#474F5C',
			60: '#636972',
			50: '#91979F',
			40: '#AFB4BB',
			30: '#CBD0D6',
			20: '#DFE5EC',
			10: '#EEF1F7',
		},
	};

	//This is for font size
	const size: SizeTypes = {
		ma2: '48px', // massive
		ma1: '32px',
		lg2: '28px', //large,
		lg1: '24px',
		rg3: '20px', // regular,
		rg2: '16px',
		rg1: '14px',
		sm2: '12px',
		sm1: '10px',
	};

	const font: FontTypes = {
		source:
			'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap',
		family: 'Inter, sans-serif',
		weight: {
			bold: 700,
			semiBold: 600,
			medium: 500,
			regular: 400,
			light: 300,
		},
	};

	const text: TextTypes = {
		fontSize: size.rg1,
		color: color.text,
		letterSpacing: 'normal',
		lineHeight: 1,
		fontWeight: font.weight.regular,
	};

	const typography: TypograhyTypes = {
		formLabel: `
        color:${color.gray[90]};
        font-size:${size.rg2};
        letter-spacing:-0.02;
        font-weight:${font.weight.medium};
        line-height:1.4;
      `,
		input: `
        color:${color.gray[70]};
        font-size:${size.rg1};
        letter-spacing:0;
        font-weight:${font.weight.medium};
        lineHeight:1.5;
      `,
		breadCrumbs: `
        color:${color.text};
        font-size:${size.sm2};
        letter-spacing:0;
        line-height:1.5;
        font-weight:${font.weight.regular};
      `,
		btnText: `
        color:${color.text};
        font-size:${size.rg1};
        line-height:1.5;
        line-spacing:0;
        font-weight:${font.weight.medium};
     `,
		textOnlyBtnText: `
        color:${color.text};
        font-size:${size.rg1};
        font-weight:${font.weight.medium}
        letterSpacing:0;
        lineHeight:1.5;
     `,
		statsValue: `
        color:${color.gray[80]};
        font-size:${size.rg1};
        letter-spacing:0;
        line-height:1.5;

        font-weight:${font.weight.medium};
      `,
		statsLabel: `
        color:${color.gray[60]};
        font-size:${size.rg1};
        letter-spacing:0;
        line-height:1.5;

        font-weight: ${font.weight.regular};
      `,
		menuItem: `
        color:${color.text};
        font-size:${size.rg1};
        letter-spacing:0;
        line-height:1.5;
        font-weight: ${font.weight.regular};
      `,

		collectionHeader: `
        color:${color.text};
        font-size:${size.rg3};
        letter-spacing:0;
        line-height:1.3;
        font-weight: ${font.weight.medium};
      `,
		feedbackText: `
        color:${color.gray[60]};
        font-size:${size.rg1};
        letter-spacing:0;
        line-height:1.5;
        font-weight: ${font.weight.regular};
      `,
	};

	const customTheme = {
		...currentTheme,
		color,
		size,
		text,
		font,
		btn: {
			primary: 'color',
		},
		spacing,
		typography,
		boxShadow: {
			lg: '0px 4px 20px rgba(52, 60, 70, 0.2)',
			rg: '0px 4px 10px rgba(52, 60, 70, 0.1)',
		},
		checkbox: {
			label: `${typography.input}`,
		},
		input: `${typography.input}`,
		select: {
			option: {
				color: color.text,
				fontSize: size.rg2,
				letterSpacing: 0,
				fontWeight: font.weight.regular,
			},
		},
	};
	return customTheme;
};
export default theme;
